import React from 'react';
import { Box, Grid } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { FormAccordionItemList } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { FormValuesType } from 'src/UI/dynamicUI/types';
import { PercentageOrPoundField } from 'src/financial/financial-data/financial-item/forms/common/PercentageOrPoundField';

type FeeFormAccordionItemListProps = {
  isEditing: boolean;
  form: UseFormReturnType<FormValuesType>;
  feeType: string;
};

export const FeeFormAccordionItemList = ({
  form,
  isEditing,
  feeType,
}: FeeFormAccordionItemListProps) => {
  const untypedItems = form.getValues()[feeType];
  const fees = Array.isArray(untypedItems) ? untypedItems : [];

  const handleAddFee = () => {
    form.insertListItem(feeType, {
      id: null,
      fee_type: null,
      amount_type: 'CURRENCY_AMOUNT',
      amount: null,
      frequency: null,
      payment_source: null,
      amount_received: null,
      amount_received_date: null,
    });
  };

  return (
    <FormAccordionItemList
      value="fee"
      label="Fees"
      counterLabel="Fees"
      button={{
        label: 'Add fee',
        onClick: handleAddFee,
      }}
      isEditing={isEditing}
      form={form}
      entityType={feeType}
    >
      {fees.map((_, index) => (
        <Box key={index}>
          <Grid>
            <GridPair
              first={<FinancialFormField field="fee_type" index={index} product={feeType} />}
              second={
                <PercentageOrPoundField
                  form={form}
                  formFieldName="amount"
                  percentageOrPoundFieldName="amount_type"
                  index={index}
                  product={feeType}
                />
              }
            />
            <GridPair
              first={<FinancialFormField field="frequency" index={index} product={feeType} />}
              second={<FinancialFormField field="payment_source" index={index} product={feeType} />}
            />
            <GridPair
              isHighlighted
              first={<FinancialFormField field="amount_received" index={index} product={feeType} />}
              second={
                <FinancialFormField field="amount_received_date" index={index} product={feeType} />
              }
            />
          </Grid>
        </Box>
      ))}
    </FormAccordionItemList>
  );
};
